// Items in the drive are dragged onto a folder to move them there. A drag of them carries a type of
// its own, so it can be told apart from files dragged in from the computer, which are uploads: the
// drop zone under the listing leaves a drag of items alone, and a folder leaves a drag of files to
// the drop zone. Which items are being dragged is kept by the drive itself rather than read off the
// drag, since a browser only lets a drag's contents be read once it is dropped, and a folder has to
// know before then whether it can take them.
import {useState} from 'react'

export const ITEMS_TYPE = 'application/x-drive-items'

export const carriesItems = event => Array.from(event.dataTransfer?.types || []).includes(ITEMS_TYPE)

/**
 * The handlers that make an element a place items can be dropped, and whether a drag of them is
 * over it now. Without "onDrop" the element takes nothing.
 */
const useItemDrop = onDrop => {
  const [over, setOver] = useState(false)

  if (!onDrop) return [false, {}]

  const handleDragOver = event => {
    if (!carriesItems(event)) return

    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
    setOver(true)
  }

  // Moving between the element's own children fires a leave for the one left behind.
  const handleDragLeave = event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOver(false)
  }

  const handleDrop = event => {
    if (!carriesItems(event)) return

    event.preventDefault()
    event.stopPropagation()
    setOver(false)
    onDrop()
  }

  return [over, {onDragEnter: handleDragOver, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop}]
}

export default useItemDrop
